import { useMutation } from '@tanstack/react-query';

import { signupApi } from '../api/signup.adapter';
import type {
  SendCodeInput,
  SignupInput,
  VerifyCodeInput,
} from '../types/signup.types';

// request-otp / verify-otp / signup all return 204 — mutations resolve void.
export function useSendCodeMutation() {
  return useMutation<void, unknown, SendCodeInput>({
    mutationFn: (input) => signupApi.sendCode(input),
  });
}

export function useVerifyCodeMutation() {
  return useMutation<void, unknown, VerifyCodeInput>({
    mutationFn: (input) => signupApi.verifyCode(input),
  });
}

export function useCompleteSignupMutation() {
  return useMutation<void, unknown, SignupInput>({
    mutationFn: (input) => signupApi.completeSignup(input),
  });
}
